(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["delune-brand-spotlight"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('dbs-slider')){customElements.define('dbs-slider',class extends HTMLElement{connectedCallback(){this.v=this.querySelector('[data-view]');this.t=this.querySelector('[data-track]');this.a=[...this.querySelectorAll('[data-item]')];this.p=this.querySelector('[data-prev]');this.n=this.querySelector('[data-next]');this.g=this.querySelector('[data-progress]');if(!this.v||!this.a.length)return;this.u=()=>this.update();this.p?.addEventListener('click',()=>this.move(-1));this.n?.addEventListener('click',()=>this.move(1));this.v.addEventListener('scroll',this.u,{passive:true});window.addEventListener('resize',this.u);requestAnimationFrame(this.u)}move(d){let x=this.a[0].getBoundingClientRect().width+(parseFloat(getComputedStyle(this.t).gap)||0),q=Math.max(1,Math.floor(this.v.clientWidth/x));this.v.scrollBy({left:d*x*q,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'})}update(){let m=Math.max(0,this.v.scrollWidth-this.v.clientWidth),x=Math.min(m,Math.abs(this.v.scrollLeft)),r=m?x/m:0;if(this.p)this.p.hidden=m<2||r<=.01;if(this.n)this.n.hidden=m<2||r>=.99;if(this.g){let w=Math.max(18,Math.min(1,this.v.clientWidth/this.v.scrollWidth)*100);this.g.style.width=w+'%';this.g.style.left=r*(100-w)+'%'}}})}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["delune-footer-benefits"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('delune-footer-slider')) {
    class DeluneFooterSlider extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-slider-track]');
        this.slides = Array.from(this.querySelectorAll('[data-slider-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-slider-dot]'));

        this.pageSize = 2;
        const pageCount = Math.ceil(this.slides.length / this.pageSize);

        if (!this.track || this.slides.length < 2 || this.dots.length !== pageCount) return;

        this.frame = null;
        this.onScroll = this.onScroll.bind(this);
        this.onResize = this.onResize.bind(this);
        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onResize, { passive: true });

        this.dots.forEach((dot, index) => {
          dot.addEventListener('click', () => {
            this.slides[index * this.pageSize].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
          });
        });

        this.updateActiveDot();
      }

      disconnectedCallback() {
        if (!this.track) return;
        this.track.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onResize);
        if (this.frame) cancelAnimationFrame(this.frame);
      }

      onScroll() {
        if (this.frame) cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.updateActiveDot());
      }

      onResize() {
        this.updateActiveDot();
      }

      updateActiveDot() {
        const pageWidth = this.track.clientWidth;
        const rawIndex = pageWidth > 0 ? Math.round(Math.abs(this.track.scrollLeft) / pageWidth) : 0;
        const activeIndex = Math.min(rawIndex, this.dots.length - 1);

        this.dots.forEach((dot, index) => {
          dot.setAttribute('aria-current', index === activeIndex ? 'true' : 'false');
        });
      }
    }

    customElements.define('delune-footer-slider', DeluneFooterSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["delune-guidance-links"] && !Shopify.designMode) return;
  try {
    
  if(!customElements.get('delune-guidance-carousel')){class DeluneGuidanceCarousel extends HTMLElement{connectedCallback(){this.viewport=this.querySelector('[data-viewport]');this.items=[...this.querySelectorAll('[data-item]')];this.previous=this.querySelector('[data-prev]');this.next=this.querySelector('[data-next]');if(!this.viewport||!this.items.length)return;this.previous?.addEventListener('click',()=>this.move(-1));this.next?.addEventListener('click',()=>this.move(1));this.viewport.addEventListener('scroll',()=>this.updateButtons(),{passive:true});window.addEventListener('resize',()=>this.updateButtons());this.updateButtons()}move(direction){const firstItem=this.items[0];const itemWidth=firstItem?.getBoundingClientRect().width||this.viewport.clientWidth;const gap=parseFloat(getComputedStyle(this.querySelector('.delune-guidance__track')).gap)||0;const visibleItems=Math.max(1,Math.floor(this.viewport.clientWidth/(itemWidth+gap)));this.viewport.scrollBy({left:(itemWidth+gap)*visibleItems*direction,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'})}updateButtons(){if(!this.previous||!this.next)return;const edge=8;const end=this.viewport.scrollWidth-this.viewport.clientWidth-edge;this.previous.hidden=Math.abs(this.viewport.scrollLeft)<=edge;this.next.hidden=Math.abs(this.viewport.scrollLeft)>=end}}customElements.define('delune-guidance-carousel',DeluneGuidanceCarousel)}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["delune-hero-promo-carousel"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('delune-hero-carousel')) {
  class DeluneHeroCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-hero-track]');
      this.items = Array.from(this.querySelectorAll('[data-hero-item]'));
      this.previousButton = this.querySelector('[data-hero-previous]');
      this.nextButton = this.querySelector('[data-hero-next]');
      this.currentIndex = 0;
      this.frame = null;
      if (!this.track || this.items.length < 2) return;

      this.handleScroll = () => {
        if (this.frame) cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.update());
      };
      this.handlePrevious = () => this.goTo(this.currentIndex - 1);
      this.handleNext = () => this.goTo(this.currentIndex + 1);
      this.handleResize = () => this.update();
      this.handleBlockSelect = (event) => {
        const item = event.target.closest('[data-hero-item]');
        if (!item || !this.contains(item)) return;
        const index = this.items.indexOf(item);
        if (index >= 0) this.goTo(index, false);
      };

      this.track.addEventListener('scroll', this.handleScroll, { passive: true });
      this.previousButton?.addEventListener('click', this.handlePrevious);
      this.nextButton?.addEventListener('click', this.handleNext);
      window.addEventListener('resize', this.handleResize);
      document.addEventListener('shopify:block:select', this.handleBlockSelect);
      this.update();
    }

    disconnectedCallback() {
      this.track?.removeEventListener('scroll', this.handleScroll);
      this.previousButton?.removeEventListener('click', this.handlePrevious);
      this.nextButton?.removeEventListener('click', this.handleNext);
      window.removeEventListener('resize', this.handleResize);
      document.removeEventListener('shopify:block:select', this.handleBlockSelect);
      if (this.frame) cancelAnimationFrame(this.frame);
    }

    getItemOffset(item) {
      const trackRect = this.track.getBoundingClientRect();
      const itemRect = item.getBoundingClientRect();
      const direction = getComputedStyle(this.track).direction;
      if (direction === 'rtl') {
        return this.track.scrollLeft + (trackRect.right - itemRect.right);
      }
      return this.track.scrollLeft + (itemRect.left - trackRect.left);
    }

    goTo(index, animate = true) {
      const nextIndex = Math.max(0, Math.min(index, this.items.length - 1));
      const item = this.items[nextIndex];
      if (!item) return;
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.track.scrollTo({
        left: this.getItemOffset(item),
        behavior: animate && !reduceMotion ? 'smooth' : 'auto'
      });
      this.currentIndex = nextIndex;
      this.renderState();
    }

    update() {
      const trackRect = this.track.getBoundingClientRect();
      const direction = getComputedStyle(this.track).direction;
      let nearestIndex = 0;
      let nearestDistance = Number.POSITIVE_INFINITY;

      this.items.forEach((item, index) => {
        const itemRect = item.getBoundingClientRect();
        const distance = direction === 'rtl'
          ? Math.abs(trackRect.right - itemRect.right)
          : Math.abs(itemRect.left - trackRect.left);
        if (distance < nearestDistance) {
          nearestDistance = distance;
          nearestIndex = index;
        }
      });

      this.currentIndex = nearestIndex;
      this.renderState();
    }

    renderState() {
      const maxScroll = Math.max(0, this.track.scrollWidth - this.track.clientWidth - 2);
      const rawScroll = Math.abs(this.track.scrollLeft);
      const isAtStart = rawScroll <= 2 && this.currentIndex === 0;
      const isAtEnd = rawScroll >= maxScroll || this.currentIndex >= this.items.length - 1;
      if (this.previousButton) this.previousButton.disabled = isAtStart;
      if (this.nextButton) this.nextButton.disabled = isAtEnd;
    }
  }

  customElements.define('delune-hero-carousel', DeluneHeroCarousel);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["delune-news-article"]) return;
  try {
    
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-delune-share]');
    if (!button) return;

    var url = button.getAttribute('data-share-url');
    var note = button.parentElement.querySelector('[data-delune-share-note]');

    if (navigator.share) {
      navigator.share({ title: button.getAttribute('data-share-title'), url: url }).catch(function () {});
      return;
    }

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(
        function () { if (note) note.textContent = 'Link copied'; },
        function () { if (note) note.textContent = url; }
      );
    } else if (note) {
      note.textContent = url;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["editorial-promo-cards"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('editorial-card-carousel')) {
    customElements.define(
      'editorial-card-carousel',
      class extends HTMLElement {
        connectedCallback() {
          this.t = this.querySelector('[data-carousel-track]');
          this.i = [...this.querySelectorAll('[data-carousel-item]')];
          this.d = [...this.querySelectorAll('[data-carousel-dot]')];
          this.p = this.querySelector('[data-carousel-previous]');
          this.n = this.querySelector('[data-carousel-next]');
          this.x = 0;

          if (!this.t || this.i.length < 2) return;

          this.u = () => {
            if (matchMedia('(min-width: 750px)').matches) return;
            const r = this.t.getBoundingClientRect();
            const c = r.left + r.width / 2;
            let j = 0;
            let m = Infinity;

            this.i.forEach((e, k) => {
              const q = e.getBoundingClientRect();
              const z = Math.abs(q.left + q.width / 2 - c);
              if (z < m) {
                m = z;
                j = k;
              }
            });

            this.x = j;
            this.s();
          };

          this.g = (k) => {
            this.x = Math.max(0, Math.min(k, this.i.length - 1));
            this.i[this.x].scrollIntoView({
              behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
              block: 'nearest',
              inline: 'start',
            });
            this.s();
          };

          this.t.addEventListener('scroll', this.u, { passive: true });
          this.p?.addEventListener('click', () => this.g(this.x - 1));
          this.n?.addEventListener('click', () => this.g(this.x + 1));
          this.d.forEach((e, k) => e.addEventListener('click', () => this.g(k)));
          this.s();
        }

        s() {
          this.p?.toggleAttribute('disabled', this.x === 0);
          this.n?.toggleAttribute('disabled', this.x === this.i.length - 1);
          this.d.forEach((e, k) => {
            e.classList.toggle('is-active', k === this.x);
            if (k === this.x) {
              e.setAttribute('aria-current', 'true');
            } else {
              e.removeAttribute('aria-current');
            }
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  // Delune: the "Account" word beside the icon sits outside the popover's own button, so a click on it
  // presses that button too.
  document.addEventListener('click', (event) => {
    const account = event.target instanceof HTMLElement && event.target.matches('shopify-account') ? event.target : null;
    if (!account || event.composedPath()[0] !== account) return;
    account.shadowRoot?.querySelector('button[aria-haspopup]')?.click();
  });

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kluck-ai-section-1"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  const mainImage = document.getElementById('main-product-image');
  const thumbnails = document.querySelectorAll('.product-two-panel__thumbnail');

  thumbnails.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      mainImage.src = thumb.dataset.full;
    });
  });

  // Scroll arrows
  const prev = document.querySelector('.thumb-prev');
  const next = document.querySelector('.thumb-next');
  const container = document.querySelector('.product-two-panel__thumbnails');

  next.addEventListener('click', () => {
    container.scrollBy({ left: 100, behavior: 'smooth' });
  });

  prev.addEventListener('click', () => {
    container.scrollBy({ left: -100, behavior: 'smooth' });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
  if (!customElements.get('delune-recently-viewed')) {
    customElements.define(
      'delune-recently-viewed',
      class extends HTMLElement {
        connectedCallback() {
          const key = 'delune:recently-viewed';
          const handle = this.dataset.handle;
          const limit = parseInt(this.dataset.limit, 10) || 4;
          let list = [];

          try {
            list = JSON.parse(localStorage.getItem(key)) || [];
          } catch (e) {
            list = [];
          }
          if (!Array.isArray(list)) list = [];

          // Everything seen before this page, newest first; then remember this page for next time
          const others = list.filter((h) => typeof h === 'string' && h && h !== handle);
          this.save(key, [handle, ...others]);

          this.key = key;
          this.handles = others.slice(0, limit);
          if (!this.handles.length) return;

          if ('IntersectionObserver' in window) {
            const observer = new IntersectionObserver(
              (entries) => {
                if (!entries.some((entry) => entry.isIntersecting)) return;
                observer.disconnect();
                this.load();
              },
              { rootMargin: '0px 0px 800px 0px' }
            );
            observer.observe(this.parentElement);
          } else {
            this.load();
          }
        }

        save(key, handles) {
          try {
            localStorage.setItem(key, JSON.stringify(handles.slice(0, 12)));
          } catch (e) {
            // Storage can be unavailable (private windows, blocked site data); the row simply stays hidden
          }
        }

        load() {
          const root = (this.dataset.root || '/').replace(/\/$/, '');
          const list = this.querySelector('ul');
          const gone = [];

          Promise.all(
            this.handles.map((h) =>
              fetch(`${root}/products/${encodeURIComponent(h)}?section_id=delune-recently-viewed-card`)
                .then((response) => {
                  if (response.status === 404) gone.push(h);
                  return response.ok ? response.text() : '';
                })
                .catch(() => '')
            )
          ).then((parts) => {
            const holder = document.createElement('template');

            parts.forEach((html) => {
              if (!html) return;
              holder.innerHTML = html;
              const card = holder.content.querySelector('li');
              if (!card) return;

              // The reviews app takes each card's rating from data set by the card's inline script. Scripts
              // inserted as HTML do not run, so run them first; otherwise the app shows this page's rating.
              card.querySelectorAll('script').forEach((inert) => {
                const live = document.createElement('script');
                live.textContent = inert.textContent;
                document.head.appendChild(live).remove();
              });

              list.appendChild(card);
            });

            // Forget products that no longer exist
            if (gone.length) {
              try {
                const kept = (JSON.parse(localStorage.getItem(this.key)) || []).filter((h) => !gone.includes(h));
                this.save(this.key, kept);
              } catch (e) {
                // Nothing to tidy
              }
            }

            if (list.children.length) this.hidden = false;
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sephora-collection-carousel"] && !Shopify.designMode) return;
  try {
     if (!customElements.get('sephora-carousel')) { class SephoraCarousel extends HTMLElement { connectedCallback() { this.viewport = this.querySelector('[data-viewport]'); this.items = [...this.querySelectorAll('[data-item]')]; this.previousButton = this.querySelector('[data-prev]'); this.nextButton = this.querySelector('[data-next]'); if (!this.viewport || !this.items.length) return; this.handleScroll = () => this.updateState(); this.handleResize = () => this.updateState(); this.previousButton?.addEventListener('click', () => this.move(-1)); this.nextButton?.addEventListener('click', () => this.move(1)); this.viewport.addEventListener('scroll', this.handleScroll, { passive: true }); window.addEventListener('resize', this.handleResize); this.bindCardLinks(); this.updateState(); } disconnectedCallback() { this.viewport?.removeEventListener('scroll', this.handleScroll); window.removeEventListener('resize', this.handleResize); } bindCardLinks() { const interactiveSelector = 'a, button, input, select, textarea, summary, [role="button"], [data-no-card-link]'; this.querySelectorAll('[data-card-clickable="true"][data-product-url]').forEach((card) => { if (card.dataset.cardClickBound === 'true') return; card.dataset.cardClickBound = 'true'; card.addEventListener('click', (event) => { if (event.defaultPrevented || event.target.closest(interactiveSelector)) return; const productUrl = card.dataset.productUrl; if (!productUrl) return; if (event.metaKey || event.ctrlKey || event.shiftKey) { window.open(productUrl, '_blank', 'noopener'); return; } window.location.assign(productUrl); }); }); } move(direction) { const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'; this.viewport.scrollBy({ left: direction * this.viewport.clientWidth, behavior }); } updateState() { const end = this.viewport.scrollWidth - this.viewport.clientWidth - 8; this.previousButton.hidden = Math.abs(this.viewport.scrollLeft) <= 8; this.nextButton.hidden = Math.abs(this.viewport.scrollLeft) >= end; } } customElements.define('sephora-carousel', SephoraCarousel); } 
  } catch(e) { console.error(e); }
})();
})();
